export default {"src":"/_next/static/media/Convenient.f8a62379.svg","height":80,"width":80};